import React from 'react';
import { Route, Link, Redirect } from 'react-router-dom';
import { startCase } from 'lodash';
import pluralize from 'pluralize';
import Footer from './Footer';

function IndexRoute(props) {
  const { config, history } = props;
  if (history.location.pathname === '/' && config.initialPath) {
    return <Redirect to={config.initialPath} />;
  }

  const indexRouteElement = (
    <Route
      exact
      path="/"
      render={() => {
        const resourceLinks = config.resources
          .filter(resource => !resource.name.startsWith('sample') && !resource.name.startsWith('template'))
          .reduce((acc, resource) => {
            if (resource.crudMapping.readMany) {
              const resourceName = resource.displayName || resource.name;
              const resourceSubtitle = resource.subtitle;
              acc.push(
                <tr key={resourceName}>
                  <td>
                    <Link to={`/${resourceName}`}>
                      {startCase(pluralize(resourceName))}
                    </Link>
                  </td>
                  {resourceSubtitle ? <td>{resourceSubtitle}</td> : null}
                </tr>,
              );
            }
            return acc;
          }, []);

        const samplesLinks = config.resources
          .filter(resource => resource.name.startsWith('sample'))
          .reduce((acc, resource) => {
            if (resource.crudMapping.readMany) {
              const resourceName = resource.displayName || resource.name;
              acc.push(
                <tr key={resourceName}>
                  <td>
                    <Link to={`/${resourceName}`}>
                      {startCase(pluralize(resourceName)).replace(
                        /sample/gi,
                        '',
                      )}
                    </Link>
                  </td>

                </tr>,
              );
            }
            return acc;
          }, []);

        const templateLinks = config.resources
          .filter(resource => resource.name.startsWith('template'))
          .reduce((acc, resource) => {
            if (resource.crudMapping.readMany) {
              const resourceName = resource.displayName || resource.name;
              const resourceSubtitle = resource.subtitle;
              acc.push(
                <tr key={resourceName}>
                  <td>
                    <Link to={`/${resource.name}`}>
                      {startCase(pluralize(resourceName)).replace(
                        /template/gi,
                        '',
                      )}
                    </Link>
                  </td>
                  {resourceSubtitle ? <td>{resourceSubtitle}</td> : null}
                </tr>,
              );
            }
            return acc;
          }, []);

        return (
          <div>
            <h1>{config.mainTitle || 'Site Administration'}</h1>
            <h3 className={`cms-main-section-title${config.modelsTitle === 'My Curated Content' ? ' green-background' : ''}`}>
              {config.modelsTitle || 'EncourageX Data'}
            </h3>
            <table className="table table-striped">
              <tbody>{resourceLinks}</tbody>
            </table>
            {samplesLinks && samplesLinks.length ? (
              <div>
                <h3 className="cms-main-section-title">
                  {config.samplesTitle || 'Curator Samples'}
                </h3>
                <table className="table table-striped">
                  <tbody>{samplesLinks}</tbody>
                </table>
              </div>
            ) : null}
            {templateLinks && templateLinks.length ? (
              <div>
                <h3 className="cms-main-section-title">
                  {config.templateTitle || 'Template Library'}
                </h3>
                <table className="table table-striped">
                  <tbody>{templateLinks}</tbody>
                </table>
              </div>
            ) : null}
            {
              config.modelsTitle === 'My Curated Content' && false ?
                <Footer />
                : null
            }
          </div>
        );
      }}
    />
  );

  return indexRouteElement;
}

export default IndexRoute;



// WEBPACK FOOTER //
// ./src/byob-cms/src/AppLib/IndexRoute.js